import { FunctionComponent, useRef } from "react";
import { Drawer } from "antd";
import { useViewport } from "@utils/breakpoints-helper";
import { CloseOutlined } from "@ant-design/icons";

interface BasicDrawerProps {
  title: string | JSX.Element;
  visible: boolean;
  onClose: () => void;
  children: string | JSX.Element;
  footer?: JSX.Element | null;
  className?: string;
}

const BasicDrawer: FunctionComponent<BasicDrawerProps> = ({
  title,
  visible,
  onClose,
  children,
  footer = null,
  className = "",
}) => {
  const { width } = useViewport();
  const closeRef = useRef<HTMLSpanElement>(null);

  const handleBlur = () => {
    if (closeRef) closeRef.current?.focus();
  };

  return (
    <Drawer
      title={title}
      visible={visible}
      placement={width >= 576 ? "left" : "bottom"}
      onClose={onClose}
      footer={footer}
      className={`app-drawer ${className}`}
      closeIcon={
        <CloseOutlined
          tabIndex={0}
          ref={closeRef}
          onKeyPress={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClose();
            }
          }}
        />
      }
    >
      <div>{children}</div>
      <div tabIndex={0} onFocus={handleBlur}></div>
    </Drawer>
  );
};

export default BasicDrawer;
